module.exports = __webpack_public_path__ + "img/banner-19.fdf775c9.jpg";